<template lang='pug' src='./tab-braces-faq.pug'></template>

<script>
import { showTab } from '@/mixins.js'

export default {
  props: ['props'],
  data () {
    return {
      titleActive: false
    }
  },
  mixins: [showTab]
}
</script>



// WEBPACK FOOTER //
// tab-braces-faq.vue?685a6c61